<label class="field-label">
  {{ label }}
  @if (isRequired) {
  <span class="text-red-600" aria-hidden="true">*</span>
  }
</label>
@if (otherInfo) {
<p class="text-dc-navy! mb-2">{{ otherInfo }}</p>
}
@if (this.isMultiple && this.maxSelectLimit && (this.control.value?.length === this.maxSelectLimit && selectElement.focused)) {
	<div class="text-red-600 mb-2 text-xs">
		<span>Max selection reached</span>
	</div>
}
<ng-select
  #selectElement
  [formControl]="control"
  [items]="options"
  [bindLabel]="labelKey"
  [bindValue]="valueKey"
  [attr.title]="getSelectedTooltip()"
  [placeholder]="placeholder ? placeholder : ('SELECT' | translate)"
  [loading]="loading"
  [typeahead]="typeahead$"
  [editableSearchTerm]="false"
  groupBy="relationships"
  [searchable]="!showMemberFilter"
  [compareWith]="compareWith"
  [clearable]="!isControlReadonly"
  (change)="selectionChange($event)"
  (search)="onType($event)"
  [multiple]="isMultiple"
  [maxSelectedItems]="maxSelectLimit ? maxSelectLimit : (options ? options?.length : 999)"
>
  <ng-template ng-optgroup-tmp let-item="item">
    {{ item[labelKey] }}
  </ng-template>
  <!-- Header Template -->

  @if(showMemberFilter){
  <ng-template ng-header-tmp>
    <div class="p-2">
      <label class="block text-sm font-semibold text-dc-navy">
        {{ "SEARCH_BY" | translate }}
      </label>

      <!-- Radio Buttons -->
      <div class="flex gap-4 text-sm">
        @for (filterBy of searchByOptionsToUse; track $index) {
        <label class="flex items-center gap-x-2 py-2">
          <input
            type="radio"
            name="searchBy"
            [value]="filterBy.value"
            [(ngModel)]="searchBy"
            (change)="onSearchByChange()"
            class="form-radio h-5 w-5 text-dc-navy border-gray-300 accent-dc-navy"
          />
          <span class="text-sm text-dc-navy">
            {{ filterBy.label | translate }}
          </span>
        </label>
        }
      </div>

      <!-- Search Input + Buttons -->
      <div class="flex items-center gap-3 mt-2">
        <input
          class="w-full px-3 py-2 text-dc-navy border border-dc-navy focus:outline-none disabled:cursor-not-allowed"
          type="text"
          [(ngModel)]="searchText"
          [placeholder]="'SEARCH_HERE' | translate"
        />

        <!-- Search Button -->
        <app-button
          [label]="'BUTTONS.SEARCH' | translate"
          [classesName]="''"
          (onBtnClick)="onSearchClick()"
          [disabled]="loading"
        ></app-button>
        <!-- <button
            class="px-4 py-2 bg-dc-navy text-white text-sm rounded hover:bg-dc-dark-blue"
            (click)="onSearchClick()"
          >
            {{ 'BUTTONS.SEARCH' | translate }}
          </button> -->

        <!-- Clear Button -->
        <app-button
          [label]="'BUTTONS.CLEAR' | translate"
          [classesName]="'card-edge-cut-white'"
          (onBtnClick)="onClearClick()"
        ></app-button>
      </div>
    </div>
  </ng-template>
  }

  <!-- option rows -->
  <ng-template ng-option-tmp let-item="item">
  @if(country){
  <span
      class="fi fi-{{ getCountryCode(item.Name) | lowercase }} mr-1"
      aria-hidden="true"
    ></span
  >}
  <span
      [ngClass]="item.isGroupTitle ? 'font-bold' : 'font-light'"
      [innerHTML]="getLabel(item)"
      [attr.title]="showSelectedTooltip ? getLabel(item) : null"
    >
    </span>
  @if(item['Account Number'] || item['DC License Registration Number']){
  <span class="w-full grid grid-cols-1 text-sm font-light">
    <span>
        {{ "SEARCH_BY_MEM_NUMBER" | translate }}:
        {{ item["Account Number"] }}</span
      >
      <span
        >{{ "SEARCH_BY_MEM_LICENSE" | translate }}:
        {{ item["DC License Registration Number"] }}</span
      >
    </span>
    }
  </ng-template>

  <!-- what shows when closed -->
  <ng-template ng-label-tmp let-item="item">
    @if(country){<span
      class="fi fi-{{ getCountryCode(item.Name) | lowercase }} mr-1"
      aria-hidden="true"
    ></span
    >}
     @if(isMultiple){
      <span
        class="fa fa-remove mr-1"
        [class.cursor-pointer]="!isControlReadonly"
        [class.opacity-40]="isControlReadonly"
        [attr.role]="isControlReadonly ? null : 'button'"
        [attr.tabindex]="isControlReadonly ? -1 : 0"
        [attr.aria-label]="isControlReadonly ? null : 'Remove'"
        [attr.aria-disabled]="isControlReadonly"
        (click)="removeSelectedItem(item, $event)"
      ></span>
    }
    <span [attr.title]="getLabel(item)">
      {{ getTruncatedLabel(item) }}
    </span>
  </ng-template>

  <!-- loader inside dropdown -->
  <ng-template ng-loading-text>
    <div class="flex items-center gap-2">
      <i class="fa fa-spinner fa-spin text-gray-500"></i>
      <span>{{ "LOADING" | translate }}</span>
    </div>
  </ng-template>
  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
    <span class="text-[#cacaca] inline-block p-2">{{
      "NO_ITEM_FOUND" | translate
    }}</span>
  </ng-template>
</ng-select>
<div class="fields-error-container">
  <!-- Show custom error messages -->
  @if (control.touched && control.invalid) { @for (errorKey of errorKeys; track
  errorKey) { @if (control.hasError(errorKey)) {
  {{
    validationMessages[errorKey] ||
      (errorKey === "required"
        ? ("VALIDATION_MSG.FIELD_REQUIRED" | translate)
        : "Invalid value")
  }}
  } } }
</div>
